window.onload = function(e){ 
   var checkOut = document.getElementById('checkout-button');
  if (checkOut!==null){
          checkOut.onclick = function (){
              function gtag_report_conversion(url) {
                  window.dataLayer = window.dataLayer || [];

                  function gtag() {
                      dataLayer.push(arguments);
                  }

                  var callback = function () {
                      if (typeof (url) != 'undefined') {
                          window.location = url;
                      }
                  };
                  gtag('event', 'conversion', {'send_to': 'AW-996061915/QaBfCISdvL4DENvl-toD', 'event_callback': callback});
              }

              gtag_report_conversion();
              console.log('done');
          }
  }

    var checkOutSileout = document.getElementById('checkout-button-sileout');
    if (checkOutSileout!==null){
  	checkOutSileout.onclick = function (){
        function gtag_report_conversion(url) {
            window.dataLayer = window.dataLayer || [];

            function gtag() {
                dataLayer.push(arguments);
            }

            var callback = function () {
                if (typeof (url) != 'undefined') {
                    window.location = url;
                }
            };
            gtag('event', 'conversion', {'send_to': 'AW-996061915/QaBfCISdvL4DENvl-toD', 'event_callback': callback});
        }

        gtag_report_conversion();
        console.log('done');
    	}
    }
}